module.exports = __webpack_public_path__ + "static/citzbooking_about-cb6ea547e1439fec907b3d2d14a842c0.png";